import { Button, Col, Row } from 'antd';
import HTTPService from '../../../utils/makerequest';
import { IPageData } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication } from '../../../interfaces/authentication';
import { Toast } from 'primereact/toast';
import '../PrinterManagement/Device.css';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import moment from 'moment';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import ResponsibleManagement from '../ResponsibleManagement/ResponsibleManagement';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';

const InventoryMovementManagement: React.FunctionComponent<any> = (props) => {
  const { onSetPage } = props;
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  const [inventoryMovementData, setInventoryMovementData] = useState({ data: [], count: 0 });
  const dataGridRef = useRef<any>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const pageData: IPageData = {
    title: t('reportMovement'),
    loaded: true,
  };


  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData()
  }, [i18n.language]);


  const handleRowSelection = (newSelection: any) => {
    setSelectedRows(newSelection);
  };

  const movementType = {
    [t('Debit')]: 0,
    [t('Responsible')]: 1,
    [t('Campus')]: 2,
    [t('Location')]: 3,
    [t('InventoryStatus')]: 4,
    [t('Department')]: 5,
    [t('PeriodicMaintenance')]: 6,
    [t('FaultMaintenance')]: 7,
    [t('Transfer')]: 8
  }


  const columns: IMUIDataGridColumns[] = [
    {
      title: t('date'),
      key: 'updatedDate',
      placeHolder: t('date'),
      isSorting: true,
      dataType: 'date',
    },
    {
      title: t('inventoryName'),
      key: 'inventoryName',
      placeHolder: t('inventoryName'),
      align: 'left'
    },
    {
      title: t('barcode'),
      key: 'customBarcode',
      placeHolder: t('barcode'),
    },
    {
      title: t('movementType'),
      key: 'inventoryTracking',
      placeHolder: t('movementType'),
      align: 'left',
      enumValues: movementType,
      render: (value) => {
        return <div style={{ textAlign: 'left' }}>{t(value)}</div>;
      }
    },
    {
      title: t('oldRecord'),
      key: 'oldRecord',
      placeHolder: t('oldRecord'),
    },
    {
      title: t('newRecord'),
      key: 'newRecord',
      width: 505,
      placeHolder: t('newRecord'),
    },
  ];


  const InventoryFilter = (e?) => {
    const filters = e?.filters;


    if (filters?.updatedDate && Array.isArray(filters.updatedDate)) {
      filters.updatedDate = filters.updatedDate[0];
    }

    if (filters?.inventoryTracking !== undefined) {
      if (filters.inventoryTracking === "" || filters.inventoryTracking === null) {
        delete filters.inventoryTracking;
      } else {
        filters.inventoryTracking = [Number(filters.inventoryTracking)];
      }
    }

    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize || 50,
      page: e?.page || 1,
      companyId: userInfo?.companyId,
      ...filters,
    };

    HTTPService.POST(`/Report/filtersTracking`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        setInventoryMovementData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };


  const excelDownload = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      });
      return;
    }

    const selectedData = selectedRows.map(row => ({
      inventoryName: row.inventoryName,
      barcode: row.customBarcode || row.barcode,
      inventoryMovementType: row.inventoryTracking,
      newRecord: row.newRecord,
      oldRecord: row.oldRecord,
      updatedDate: row.updatedDate
    }));


    if (selectedData.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      });
      return;
    }

    HTTPService.POSTblobExcel('/Report/ExcelDownloadMovement', selectedData)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('excelSuccess'),
            life: 3000
          });
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        } else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((err) => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('error'),
          life: 3000
        });
      });
  };


  const pdfDownload = () => {
    if (!selectedRows || selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      });
      return;
    }

    const selectedData = selectedRows.map(row => ({
      inventoryName: row.inventoryName,
      barcode: row.customBarcode || row.barcode,
      inventoryMovementType: row.inventoryTracking,
      newRecord: row.newRecord,
      oldRecord: row.oldRecord,
      updatedDate: row.updatedDate
    }));

    if (selectedRows.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: t('mistake'),
        detail: t('NoRows'),
        life: 3000
      });
      return;
    }

    HTTPService.POSTblob('/Report/PdfDownloadMovement', selectedData)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('mistake'),
            detail: t('pdfSuccess'),
            life: 3000
          });
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        }
        else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        }
        else if (response.status === 450) {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((err) => {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t('error'),
          life: 3000
        });
      });
  };


  return (
    <>
      <Toast ref={toast} />
      <Row gutter={16} style={{ marginTop: '20px' }}>
        <Col xs={24} sm={8} md={6} lg={4} xl={4} style={{ paddingLeft: '8px' }}>


        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ marginTop: '10px', paddingLeft: '8px' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button
              type="primary"
              onClick={excelDownload}
              style={{
                height: 64,
                width: 'auto',
                backgroundColor: 'transparent',
                color: '#1890ff',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
                border: 'none',
                display: 'flex',
                left: '-5px',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
            >
              <FileExcelOutlined style={{ fontSize: 24 }} />
              <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                {t('Excel')}
              </span>
            </Button>

            <Button
              type="primary"
              onClick={pdfDownload}
              style={{
                height: 64,
                width: 'auto',
                backgroundColor: 'transparent',
                color: '#1890ff',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
                border: 'none',
                display: 'flex',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
            >
              <FilePdfOutlined style={{ fontSize: 24 }} />
              <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                {t('PDF')}
              </span>
            </Button>
          </div>
          <MUIDatagrid
            ref={dataGridRef}
            data={inventoryMovementData.data}
            total={inventoryMovementData.count}
            columns={columns}
            onSelectionChange={handleRowSelection}
            enableSelection={true}
            filterMode='server'
            onChange={InventoryFilter}
          />
        </Col>
      </Row >
    </>
  );



};

export default InventoryMovementManagement;
